module.exports = __webpack_public_path__ + "static/media/srvy-white.94f26599.png";